const $$splitComponentImporter = () => import('/build/web/src/routes/_authenticated/chat-records/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import z from 'zod';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/auth-store';
import { ROLE } from '@/lib/roles';
const sessionsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  page_size: z.number().optional().catch(50),
  // user_id 是旧的单选参数，保留只为让历史书签仍能工作；
  // 筛选栏初始化时会并进 user_ids，用户一操作就切到新参数。
  user_id: z.number().optional(),
  user_ids: z.array(z.number()).optional(),
  model_name: z.string().optional(),
  client_name: z.string().optional(),
  token_name: z.string().optional(),
  finish_reason_normalized: z.string().optional(),
  client_session_id: z.string().optional(),
  start_time: z.string().optional(),
  end_time: z.string().optional(),
  order_by: z.enum(['last_call_at desc', 'call_count desc', 'total_cost_cents_cny desc']).optional()
});
export const Route = createFileRoute('/_authenticated/chat-records/')({
  beforeLoad: () => {
    const auth = useAuthStore.getState().auth;
    if (!auth.user || auth.user.role < ROLE.ADMIN) {
      throw redirect({
        to: '/403'
      });
    }
  },
  validateSearch: sessionsSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});